var _g, _g2, _g3, _path, _g4, _g5, _path2, _path3, _g6, _g7, _g8, _g9, _path4, _path5, _path6, _path7, _g10, _path8, _g11, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSprinkler = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "smoke-detector (1)",
  viewBox: "0 0 512 512"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 36"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 255",
  d: "M226 212a75.085 75.085 0 01-75-75V75a15 15 0 0130 0v62a45.051 45.051 0 0045 45 15 15 0 010 30z",
  fill: "#465a61"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 37"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 256",
  d: "M286 212a15 15 0 010-30 45.051 45.051 0 0045-45V75a15 15 0 0130 0v62a75.085 75.085 0 01-75 75z",
  fill: "#3b4a51"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 38"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 257",
  d: "M271 75v92a15 15 0 01-30 0V75a15 15 0 0130 0z",
  fill: "#465a61"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 258",
  d: "M271 75v92a15.005 15.005 0 01-15 15V60a15.005 15.005 0 0115 15z",
  fill: "#3b4a51"
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 39"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 259",
  d: "M271 377v30a15 15 0 01-30 0v-30a15 15 0 0130 0z",
  fill: "#78e1fb"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 40"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 260",
  d: "M271 467v30a15 15 0 01-30 0v-30a15 15 0 0130 0z",
  fill: "#78e1fb"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 261",
  d: "M271 377v30a15.005 15.005 0 01-15 15v-60a15.005 15.005 0 0115 15z",
  fill: "#6cbbed"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 262",
  d: "M271 467v30a15.005 15.005 0 01-15 15v-60a15.005 15.005 0 0115 15z",
  fill: "#6cbbed"
})), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 41"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 263",
  d: "M326.606 408.82l-21.213-21.213a15 15 0 0121.213-21.213l21.213 21.213a15 15 0 11-21.213 21.213z",
  fill: "#6cbbed"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 42"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 264",
  d: "M390.246 472.459l-21.213-21.213a15 15 0 0121.213-21.213l21.213 21.213a15 15 0 01-21.213 21.213z",
  fill: "#6cbbed"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 43"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 265",
  d: "M164.181 408.82a15 15 0 010-21.213l21.213-21.213a15 15 0 0121.213 21.213l-21.213 21.213a15 15 0 01-21.213 0z",
  fill: "#78e1fb"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 44"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 266",
  d: "M100.541 472.46a15 15 0 010-21.213l21.213-21.213a15 15 0 0121.213 21.213l-21.213 21.213a15 15 0 01-21.213 0z",
  fill: "#78e1fb"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 267",
  d: "M391 15v60a15.005 15.005 0 01-15 15H136a15.005 15.005 0 01-15-15V15z",
  fill: "#e7f0ef"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 268",
  d: "M391 15v60a15.005 15.005 0 01-15 15H256V15z",
  fill: "#d8e6e8"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 269",
  d: "M301 167v90a15.005 15.005 0 01-15 15h-60a15.005 15.005 0 01-15-15v-90a15.005 15.005 0 0115-15h60a15.005 15.005 0 0115 15z",
  fill: "#596c76"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 270",
  d: "M301 167v90a15.005 15.005 0 01-15 15h-30V152h30a15.005 15.005 0 0115 15z",
  fill: "#465a61"
})), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 45"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 271",
  d: "M286 242h-60a45.055 45.055 0 00-45 45v30a15.005 15.005 0 0015 15h120a15.005 15.005 0 0015-15v-30a45.055 45.055 0 00-45-45z",
  fill: "#e7f0ef"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 272",
  d: "M331 287v30a15.005 15.005 0 01-15 15h-60v-90h30a45.055 45.055 0 0145 45z",
  fill: "#d8e6e8"
})), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 46"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 273",
  d: "M512 15a15.005 15.005 0 01-15 15H15a15 15 0 010-30h482a15.005 15.005 0 0115 15z",
  fill: "#596c76"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 274",
  d: "M512 15a15.005 15.005 0 01-15 15H256V0h241a15.005 15.005 0 0115 15z",
  fill: "#465a61"
})));
export default SvgSprinkler;